import Layout from "@/views/Layout.vue";

const home = [
  {
    path: "/home", //首页
    name: "Home",
    component: () => import("@/views/home/Index.vue"),
  },
];
const homeRouter = {
  path: "/",
  redirect: "/home",
  component: Layout,
  children: home,
};

export default homeRouter;
